module.exports = __webpack_public_path__ + "static/img/200087.0dc1e00f.png";